import type { WorkspaceSnapshotV1 } from './types';

/**
 * Type alias for the latest snapshot version.
 * As new versions are added, this always points to the latest.
 */
export type LatestSnapshot = WorkspaceSnapshotV1;

/**
 * Upgrade a snapshot to the latest version.
 *
 * Currently only V1 exists, so this is a pass-through.
 * Future versions will chain: upgradeV1toV2 → upgradeV2toV3 → ...
 */
export function upgradeSnapshot(snapshot: { v: number }): LatestSnapshot {
  if (snapshot.v === 1) {
    return snapshot as WorkspaceSnapshotV1;
  }

  throw new Error(`Unknown snapshot version: ${snapshot.v}`);
}
